export interface DynamicItem {
  date: string;
  tag: string;
  title: string;
  text: string;
}

export const dynamics: DynamicItem[] = [
  {
    date: "09-09",
    tag: "证据核实",
    title: "关键知情人「阿舟」第二批材料进入电子取证",
    text: "编辑部对新增材料进行来源校验与完整性鉴别，状态更新为「证据核实中」，是否支持进入下一阶段待定。",
  },
  {
    date: "09-08",
    tag: "人物动态",
    title: "被点名者「张某」所属团队发布更明确回应口径",
    text: "由「情况不明」转向「愿配合核实」，编辑部据此将回应与进展线索向前推进，并提示仍待独立验证。",
  },
  {
    date: "09-06",
    tag: "关系图谱",
    title: "关联当事人「陈某」列入关系图次级节点",
    text: "经资金与合同流向检索发现其与被点名者存在业务交集，当前定性为「角色待定」，不做过度解读。",
  },
  {
    date: "09-03",
    tag: "现场记录",
    title: "现场当事人「小蔡」记录完成匿名归档",
    text: "其一手时间线与材料相互吻合，作为过程佐证归入档案，仅用于校准关键节点顺序，不作责任判断。",
  },
  {
    date: "09-01",
    tag: "信源网络",
    title: "内部信源合称确立，追踪视角向机制延伸",
    text: "多名在职信源的分散片段经交叉印证后合并呈现，编辑部将关注重心从个人逐步转向流程性失序。",
  },
];